import { Style, Fill, Stroke, Circle } from 'ol/style';
import StrokePattern from "ol-ext/style/StrokePattern";
import { IStyleCache } from '../../Models/MapConfigModels';

export class TROMapStyles {
    private static style1 = new Style({ stroke: new StrokePattern({ width: 8, pattern: 'hatch', color: 'red', offset: 0, scale: 0.5, fill: new Fill({ color: 'rgba(255, 255, 255, 0.7)' }), size: 3, spacing: 8, angle: 30 }) });
    private static style2 = new Style({ stroke: new StrokePattern({ width: 8, pattern: 'hatch', color: 'red', offset: 0, scale: 0.5, fill: new Fill({ color: 'rgba(102, 255, 102, 0.7)' }), size: 3, spacing: 8, angle: 30 }) });
    private static style3 = new Style({ stroke: new StrokePattern({ width: 8, pattern: 'hatch', color: 'green', offset: 0, scale: 0.5, fill: new Fill({ color: 'rgba(102, 255, 102, 0)' }), size: 3, spacing: 8, angle: 30 }) });
    private static style4 = new Style({ stroke: new StrokePattern({ width: 8, pattern: 'hatch', color: 'Purple', offset: 0, scale: 0.5, fill: new Fill({ color: 'rgba(102, 255, 102, 0)' }), size: 3, spacing: 8, angle: 30 }) });
    private static DefaultStyle = new Style({ stroke: new StrokePattern({ width: 8, pattern: 'hatch', color: 'blue', offset: 0, scale: 0.5, fill: new Fill({ color: 'rgba(100, 100, 255, 0.7)' }), size: 3, spacing: 8, angle: 30 }) });

    static troStyleCache: Array<IStyleCache> = [
        { attributeValue: "1", attributeLabel: "Closed", showInLegend: true, style: TROMapStyles.style1 },
        { attributeValue: "2", attributeLabel: "Restricted opening", showInLegend: true, style: TROMapStyles.style2 },
        { attributeValue: "3", attributeLabel: "Restricted use", showInLegend: true, style: TROMapStyles.style3},
        { attributeValue: "4", attributeLabel: "Diversion", showInLegend: true, style: TROMapStyles.style4 },
        { attributeValue: "Default", attributeLabel: "Default", showInLegend: true, style: TROMapStyles.DefaultStyle }
    ];
}




